import { Typography } from "@mui/material";
import type { CargoOnboardParcelFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import Parcels from "@features/vessel-nomination/components/TypeAndQuantityOfCargoSection/Parcels";
import { FORM_FIELDS } from "@features/vessel-nomination/pre-nomination-request/constants";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { LANG_BASE, type PreNominationRequestOutletContext } from "../constants";

type Props = {
  formContext: PreNominationRequestOutletContext;
};

const PreNominationRequestCargoSection = ({ formContext }: Props) => {
  const { t } = useTranslation();
  const parcels = formContext.formData.watch(FORM_FIELDS.PARCELS) ?? [];
  const parcelsError = formContext.formData.formState.errors[FORM_FIELDS.PARCELS]?.message;

  const setParcels = (updatedParcels: CargoOnboardParcelFormData[]) => {
    formContext.formData.setValue(FORM_FIELDS.PARCELS, updatedParcels, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    formContext.updateFormData(FORM_FIELDS.PARCELS, updatedParcels);
  };

  const clearParcelsError = () => {
    formContext.clearErrors(FORM_FIELDS.PARCELS);
  };

  return (
    <FormProvider {...formContext.formData}>
      <div className="grid w-full grid-cols-1 gap-4">
        <Typography variant="body2">
          {t(`${LANG_BASE}.sections.type-and-quantity-of-cargo`)}
        </Typography>

        <Parcels
          parcels={parcels}
          parcelsError={typeof parcelsError === "string" ? parcelsError : undefined}
          setParcels={setParcels}
          clearParcelsError={clearParcelsError}
        />
      </div>
    </FormProvider>
  );
};

export default PreNominationRequestCargoSection;
